export default {
	id: 'SIMPLE_WORKBOOK_AGING_GRACEFULLY_14_99',
	providers: {
		paltaMap: {
			USD: 'simple_workbook_aging_gracefully_14_99_usd',
		},
		primer: 'prd_rOOFZgCaUmXy',
	},
	otp: {
		priceMap: {
			USD: 14.99,
		},
	},
}
